import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is stored in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.


function PlatformDesining() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">blueprints for better experiences</h1>
            <p className="banner-description">
            Shigjeta enhances your digital presence with custom platform designs, blending creativity, functionality, and scalability.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
        
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      {/* About Section */}
      <section className="about-section">
        {/* User-Focused Designs */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>User-Centered Designs</strong></h2>
            <p>
              Our platforms prioritize user experience, ensuring seamless navigation, engaging visuals, and optimized performance for your audience.
            </p>
            <ul>
              <li><strong>Custom Designs:</strong> Tailored interfaces for brand uniqueness.</li>
              <li><strong>Responsive:</strong> Perfect functionality across all devices.</li>
              <li><strong>Scalable:</strong> Platforms ready to grow with your business.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps2.1.png" alt="User-Focused Designs" />
          </div>
        </div>

        {/* Technology Integration */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Seamless Technology Integration</strong></h2>
            <p>
              Leveraging the latest technologies, we ensure smooth integration with your existing systems while boosting performance and reliability.
            </p>
            <ul>
              <li><strong>Cutting-Edge Tech:</strong> AI, cloud solutions, and APIs.</li>
              <li><strong>Efficiency:</strong> Tools that enhance workflow automation.</li>
              <li><strong>Security:</strong> Built-in protection for your platforms.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps2.2.png" alt="Technology Integration" />
          </div>
        </div>

        {/* Innovation and Strategy */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Innovation Meets Strategy</strong></h2>
            <p>
              We align platform strategies with business goals, driving innovation to deliver measurable success and growth.
            </p>
            <ul>
              <li><strong>Goal-Oriented:</strong> Platforms designed to meet KPIs.</li>
              <li><strong>Innovative Solutions:</strong> Combining creativity with function.</li>
              <li><strong>Result-Driven:</strong> Focused on performance and scalability.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps2.3.png" alt="Innovation Meets Strategy" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default PlatformDesining;